import { useTranslation } from 'react-i18next';
import { Box, styled, useTheme } from '@mui/material';

import { Tooltip } from '@zendesk/forethought-elements';
import flagHeartIcon from 'src/assets/images/icon-flag-heart.svg';
import { ConversationReviewRating } from 'src/services/insights/types';

interface ReviewStatusIndicatorProps {
  isFlagged?: boolean;
  reviewStatus?: ConversationReviewRating | null;
}

export const ReviewStatusIndicator = ({
  isFlagged,
  reviewStatus,
}: ReviewStatusIndicatorProps) => {
  const { t } = useTranslation('solve-insights');
  const { palette } = useTheme();

  if (reviewStatus === 'good_enough') {
    return (
      <Tooltip tooltipContent={t('reviewStatus.goodEnough')}>
        {/* eslint-disable-next-line @shopify/jsx-no-hardcoded-content -- emoji glyph, not translatable copy */}
        <Tile sx={{ backgroundColor: palette.colors.blue[100] }}>👍</Tile>
      </Tooltip>
    );
  }

  if (reviewStatus === 'missed_the_mark') {
    return (
      <Tooltip tooltipContent={t('reviewStatus.missedTheMark')}>
        {/* eslint-disable-next-line @shopify/jsx-no-hardcoded-content -- emoji glyph, not translatable copy */}
        <Tile sx={{ backgroundColor: palette.colors.red[100] }}>👎</Tile>
      </Tooltip>
    );
  }

  if (isFlagged) {
    return (
      <Tooltip tooltipContent={t('chatsTable.flaggedForHumanFeedback')}>
        <Tile sx={{ backgroundColor: palette.colors.yellow[400] }}>
          <img alt='' height={14} src={flagHeartIcon} width={14} />
        </Tile>
      </Tooltip>
    );
  }

  return null;
};

const Tile = styled(Box)`
  align-items: center;
  border-radius: 6px;
  /* The table row sets cursor: pointer to signal it's clickable, but the
     review-status tile itself isn't an interactive control (just a status
     indicator with a tooltip), so we revert to the default arrow on hover. */
  cursor: default;
  display: inline-flex;
  font-size: 14px;
  height: 28px;
  justify-content: center;
  line-height: 1;
  width: 28px;
`;
